interface BarDrinkCardProps {
  name: string;
  description?: string;
  price?: string;
  priceGlas?: string;
  priceFlaska?: string;
  size?: string;
  type?: string;
  unit?: string;
  isCompact?: boolean;
}

const BarDrinkCard = ({ 
  name, 
  description, 
  price, 
  priceGlas,
  priceFlaska,
  size, 
  type,
  unit,
  isCompact = true 
}: BarDrinkCardProps) => {
  return (
    <div className={isCompact 
      ? "bg-card/50 backdrop-blur-sm border border-gold/20 rounded-lg p-2 md:p-3 hover:border-gold/40 transition-all duration-300 hover:shadow-gold/20 hover:shadow-lg group"
      : "bg-card/50 backdrop-blur-sm border border-gold/20 rounded-lg p-4 md:p-6 hover:border-gold/40 transition-all duration-300 hover:shadow-gold/20 hover:shadow-lg group"
    }>
      <div className="flex justify-between items-start gap-3">
        <div className="flex-1">
          <h3 className={isCompact 
            ? "text-gold font-serif font-bold mb-0.5 text-sm md:text-base group-hover:text-gold-light transition-colors"
            : "text-gold font-serif font-bold mb-2 text-lg md:text-xl group-hover:text-gold-light transition-colors"
          }>
            {name}
          </h3>
          {description && (
            <p className={isCompact 
              ? "text-muted-foreground leading-snug text-[11px] md:text-xs"
              : "text-muted-foreground leading-relaxed text-sm md:text-base"
            }>
              {description}
            </p>
          )}
          {(size || type) && (
            <p className={isCompact 
              ? "text-gold/70 text-[10px] md:text-xs mt-0.5 font-medium"
              : "text-gold/70 text-xs md:text-sm mt-1 font-medium"
            }>
              {size && `${size}`}
              {type && `${type}`}
            </p>
          )}
        </div>
        <div className="flex flex-col items-end gap-1 flex-shrink-0">
          {priceGlas && priceFlaska ? (
            <>
              <span className={isCompact 
                ? "text-gold font-bold text-xs md:text-sm whitespace-nowrap"
                : "text-gold font-bold text-sm md:text-base whitespace-nowrap"
              }>
                {priceGlas}kr <span className="text-[10px] text-muted-foreground">(Glas)</span>
              </span>
              <span className={isCompact 
                ? "text-gold font-bold text-xs md:text-sm whitespace-nowrap"
                : "text-gold font-bold text-sm md:text-base whitespace-nowrap"
              }>
                {priceFlaska}kr <span className="text-[10px] text-muted-foreground">(Flaska)</span>
              </span>
            </>
          ) : (
            <span className={isCompact 
              ? "text-gold font-bold text-sm md:text-base whitespace-nowrap"
              : "text-gold font-bold text-base md:text-xl whitespace-nowrap"
            }>
              {price}kr {unit && <span className="text-xs text-muted-foreground">{unit}</span>}
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default BarDrinkCard;
